import { createSlice } from "@reduxjs/toolkit"

export const setReducer = createSlice({
    name: "setPageState",
    initialState: {
        value: null,
    },
    reducers: {
        setPageState: (state, action) => {
            state.value = action.payload
        },
    },
})

export const { setPageState } = setReducer.actions

export default setReducer.reducer
